import { createEvent, restore, sample } from 'effector'
import { StrategiesRequest, StrategiesResponse, Strategy } from './types'
import { fx } from '../../../../libs'

const changedDateFormat = (date: Date) =>
  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
const mapSearchText = (searchText: { [key: string]: string }) => {
  return Object.fromEntries(
    Object.entries(searchText).map((item) => {
      if (item[0] === 'publishedAt') {
        const value =
          Array.isArray(item[1]) &&
          item[1].map((date) =>
            date ? changedDateFormat(date?.$d) : `${date}`,
          )
        return [item[0], value]
      }
      return [item[0], item[1]?.toLowerCase()]
    }),
  )
}

const isAllElementsOfSearchTextNotExist = (searchText: {
  [key: string]: string
}) => {
  return Object.values(searchText).every((item) => item === undefined)
}
export const strategiesMounted = createEvent<StrategiesRequest>()

export const getStrategies = fx<StrategiesRequest, StrategiesResponse>({
  method: 'GET',
  url: `/strategy`,
})

export const $strategies = restore<Strategy[]>(
  getStrategies.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfStrategies = restore(
  getStrategies.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: strategiesMounted,
  fn: ({ limit, page, orderBy, orderDirection, searchText, filters }) => {
    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }
    let query = {
      limit,
      page,
    }

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    let newObj = {}

    // @ts-ignore
    if (filters?.deletedAt?.length > 0) {
      // @ts-ignore
      const value = filters.deletedAt[0]
      if (value === 'null') {
        // @ts-ignore
        newObj['deletedAt'] = 'null'
      } else if (value === 'not null') {
        // @ts-ignore
        newObj['deletedAt'] = 'not null'
      }
    } else {
      // @ts-ignore
      newObj['deletedAt'] = 'null'
    }

    if (!isAllElementsOfSearchTextNotExist(searchText)) {
      newObj = { ...newObj, ...mapSearchText(searchText) }
    }

    if (Object.keys(newObj).length) {
      // @ts-ignore
      query['where'] = `${JSON.stringify(newObj)}`
    }

    // @ts-ignore
    query['populate'] = JSON.stringify([
      'Strategy.account',
      'Strategy.client',
      'Strategy.strategySubscriptions',
    ])

    return {
      query,
    }
  },
  target: getStrategies,
})
